import { render, staticRenderFns } from "./LimitationModal.vue?vue&type=template&id=6656a268"
import script from "./LimitationModal.vue?vue&type=script&lang=js"
export * from "./LimitationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports